import React, { useState } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { TabBottomLine, TabWrapper, BorderBottom} from '../RecogntionAdmin/styles';
import Acitivity from './activityTab'
import Wellness from './wellnessTab'

const Library = ({ getColor, history }) => {
  const [activeTab, setActiveTab] = useState('Department');
  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <TabWrapper>
          <TabBottomLine active={activeTab === 'Department'} background={getColor} onClick={() => setActiveTab('Department')}>
            Activity
            <BorderBottom active={activeTab === 'Department'} background={getColor} />
          </TabBottomLine>
          <TabBottomLine active={activeTab === 'Location'} background={getColor} onClick={() => setActiveTab('Location')}>
            Wellness
            <BorderBottom active={activeTab === 'Location'} background={getColor} />
          </TabBottomLine>
        </TabWrapper>
        {activeTab==="Department"&&<Acitivity history={history}/>}
        {activeTab==="Location"&&<Wellness history={history}/>}
      </TopContainerWrapper> 
    </MainContainer>
  );
};

Library.propTypes = {
  getColor: PropTypes.func.isRequired,
  history: PropTypes.object
};

export default Library;